<template>
  <feedback-modal class="action-modal" ref="feedbackModal">

    <div class="action-modal__message">
      <slot></slot>
    </div>

    <div class="d-flex justify-center action-modal__button">
      <action-button
        :label="buttonText"
        @click.native="handleClick"
        color="error"
      />
    </div>

  </feedback-modal>
</template>

<script>

import { FeedbackModal } from '@/components/common/feedbackModal'
import ActionButton from '@/components/common/actionButton'

export default {
  components: {
    FeedbackModal,
    ActionButton,
  },
  props: {
    object: Object,
    buttonText: String
  },
  methods: {
    handleClick () {
      this.$emit('click', this.object)
      this.close()
    },
    open () {
      this.$refs.feedbackModal.open()
    },
    close () {
      this.$refs.feedbackModal.close()
    }
  }
}

</script>

<style lang="scss">

.action-modal {

  &__message {
    color: #435262;
    font-size: 17px;
    text-align: center;
  }

  &__button {
    margin: 30px auto 0 auto;
    // background-color: color(red);

    &:hover {
      color: #ffffff !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ActionModal.vue?396d0c80